import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NugetFeed } from '../../models/nuget-feed';
import { GridService } from 'src/app/shared/grid/grid.service';
import { DeveloperArtifactService } from '../../services/developer-artifact.service';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoColumnFixingModule, DxoGroupPanelModule, DxiColumnModule, DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { PasswordFieldComponent } from 'src/app/shared/password-field/password-field.component';

@Component({
    templateUrl: './nuget-feed-configuration-dialog.component.html',
    styleUrls: ['./nuget-feed-configuration-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoColumnFixingModule, DxoGroupPanelModule, DxiColumnModule, DxiValidationRuleModule, DxTemplateModule, PasswordFieldComponent]
})
export class NugetFeedConfigurationDialogComponent implements OnInit {

    nugetFeeds: NugetFeed[] = [];
    hasChanges = false;

    constructor(public modal: NgbActiveModal, private gridService: GridService, private developerArtifactService: DeveloperArtifactService) {}

    async ngOnInit(): Promise<void> {
    }

    onRowInserting = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as NugetFeed, item => this.saveNugetFeed(item, true));
    };

    onRowUpdating = (e: any): void => {
        const passwordChanged = e.oldData.Password !== (e.newData.Password ?? e.oldData.Password);
        e.cancel = this.gridService.handleDataGridRow({ ...e.oldData, ...e.newData } as NugetFeed, item => this.saveNugetFeed(item, passwordChanged), e.newData);
    };

    onRowRemoving = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as NugetFeed, item => this.deleteNugetFeed(item));
    };

    async saveNugetFeed(nugetFeed: NugetFeed, passwordChanged: boolean): Promise<NugetFeed> {
        const newNugetFeed = await this.developerArtifactService.saveNugetFeed(nugetFeed, passwordChanged);
        this.hasChanges = true;
        return newNugetFeed;
    }

    async deleteNugetFeed(nugetFeed: NugetFeed): Promise<NugetFeed> {
        await this.developerArtifactService.deleteNugetFeed(nugetFeed.Id);
        this.hasChanges = true;
        return nugetFeed;
    }

    ok(): void {
        this.modal.close(this.hasChanges);
    }

    cancel(): void {
        this.modal.dismiss(this.hasChanges);
    }

    onInitNewRow(e: any): void {
        e.data = { Id: null, Name: null, Url: null, Username: null, Password: null, Packages: null } as NugetFeed;
    }

    onPasswordValueChanged(value: string, cell: any) {
        cell.setValue(value);
    }

    onPasswordCleared(cell: any) {
        cell.setValue('');
    }

    getMaskedPassword(rowData) {
        const str = '•'.repeat(rowData.Password?.length ?? 0);
        return str;
    }
}
